import { useEffect } from 'react';

const IndexNowKey = () => {
  useEffect(() => {
    // Set document to plain text mode
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.fontFamily = 'monospace';
    document.body.style.whiteSpace = 'pre';
    document.body.style.fontSize = '12px';
    document.body.style.lineHeight = '1.4';
    document.body.style.color = '#000';
    document.body.style.backgroundColor = '#fff';
    
    // Hide all other elements
    const allElements = document.querySelectorAll('*:not(#root):not(#root *)');
    allElements.forEach(el => {
      if (el !== document.body && el !== document.documentElement) {
        (el as HTMLElement).style.display = 'none';
      }
    });
    
    return () => {
      // Reset styles on cleanup
      document.body.style.cssText = '';
    };
  }, []);

  return (
    <pre style={{ 
      margin: 0,
      padding: 0,
      fontFamily: 'monospace',
      fontSize: '12px',
      lineHeight: '1.4',
      whiteSpace: 'pre',
      color: '#000',
      backgroundColor: '#fff',
      border: 'none',
      outline: 'none'
    }}>
      wpm8hj6T5pk7rs9acryuws52anbpxegh
    </pre>
  );
};

export default IndexNowKey;